import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { waUserSupport } from '../../utils/support';

const WhatsAppSupport = () => {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <a
      href={waUserSupport(user)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com o suporte pelo WhatsApp"
      title="Precisa de ajuda? Fale conosco no WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-[#25D366]/25"
    >
      <FaWhatsapp className="h-7 w-7" aria-hidden="true" />
    </a>
  );
};

export default WhatsAppSupport;
